var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgIntroDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 820,
    height: 855,
    viewBox: "0 0 820 855",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_77_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.287 323.399C82.0304 323.399 63.8816 367.242 89.5299 392.867L223.923 527.141C242.674 545.876 268.096 556.399 294.602 556.399H365.467C391.973 556.399 417.395 566.923 436.146 585.657L597.374 746.742C616.125 765.476 641.547 776 668.053 776H1057.36C1129.9 776 1166.21 688.284 1114.89 637.015L1028.45 550.652C1009.02 531.241 1022.77 498.03 1050.23 498.03V498.03C1077.7 498.03 1091.45 464.82 1072.02 445.409L876.516 250.082C857.765 231.347 832.343 220.824 805.837 220.824H571.09C544.584 220.824 519.162 210.3 500.411 191.566L465.072 156.258C446.32 137.524 420.898 127 394.392 127H158.937C107.686 127 82.0304 188.975 118.287 225.2L147.043 253.931C172.692 279.556 154.543 323.399 118.287 323.399V323.399Z",
    fill: "#2D314D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.287 16.399C220.03 16.399 201.882 60.2417 227.53 85.8673L361.923 220.141C380.674 238.876 406.096 249.399 432.602 249.399H503.467C529.973 249.399 555.395 259.923 574.146 278.657L735.374 439.742C754.125 458.476 779.547 469 806.053 469H1195.36C1267.9 469 1304.21 381.284 1252.89 330.015L1166.45 243.652C1147.02 224.241 1160.77 191.03 1188.23 191.03V191.03C1215.7 191.03 1229.45 157.82 1210.02 138.409L1014.52 -56.9181C995.765 -75.6526 970.343 -86.1761 943.837 -86.1761H709.09C682.584 -86.1761 657.162 -96.6996 638.411 -115.434L603.072 -150.742C584.32 -169.476 558.898 -180 532.392 -180H296.937C245.686 -180 220.03 -118.025 256.287 -81.8005L285.043 -53.0693C310.692 -27.4437 292.543 16.399 256.287 16.399V16.399Z",
    fill: "url(#paint0_linear_77_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_77_2",
    x: 0.518921,
    y: 52,
    width: 1215.4,
    height: 803,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0240111 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_77_2",
    x1: -456.411,
    y1: 143.138,
    x2: 76.0916,
    y2: 1155.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33D35E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB6D9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgIntroDesktop);
export default __webpack_public_path__ + "static/media/bg-intro-desktop.dae90b01cb9ad2ae02e88e79376426a2.svg";
export { ForwardRef as ReactComponent };